import { AxiosError } from "axios";
import { useAtom } from "jotai";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { toastAtom } from "../../feedback/toast.atom";
import { ForgotPasswordType } from "../auth.service";

type ForgotPasswordFormProps = {
    onSubmit: (data: ForgotPasswordType) => Promise<unknown>;
};

type ErrorResponse = {
    message: string;
};

export const ForgotPasswordForm = ({ onSubmit }: ForgotPasswordFormProps) => {
    const [error, setErrors] = useState<ErrorResponse | undefined>(undefined);
    const [, setToast] = useAtom(toastAtom);
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm<ForgotPasswordType>();

    return (
        <>
            <form
                onSubmit={handleSubmit((data) => {
                    setErrors(undefined);
                    return onSubmit(data)
                        .then((response) => {
                            setToast({
                                type: "success",
                                message: (response as any).message,
                            });
                            return response;
                        })
                        .catch((er: AxiosError) => {
                            const errorData = (er.response
                                ?.data as ErrorResponse) || {
                                message: "error",
                            };
                            setToast({
                                type: "error",
                                message: errorData.message,
                            });
                            setErrors(errorData);
                        });
                })}
                className="flex flex-col"
            >
                <div className="mb-4">
                    <input
                        type="text"
                        placeholder="Enter email"
                        className="input input-bordered w-full"
                        {...register("email", { required: true })}
                    />
                    {errors.email && (
                        <p className="text-error-content bg-error py-1 px-3">
                            This field is required
                        </p>
                    )}
                </div>
                <div className="form-control mt-6">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn btn-primary"
                    >
                        Request Reset Password
                    </button>
                </div>
            </form>
            {!isSubmitting && error?.message && (
                <div className="alert alert-error mt-4">
                    <>{error.message}</>
                </div>
            )}
        </>
    );
};
